import React from "react";
import ReactDOM from "react-dom";
import Header from "./Header"
import Shop from "./Shop"
import Footer from "./Footer"
import Leaderboard from "./leaderboard/Leaderboard"
import "./index.css"
import Modal from "./modal/Modal";




// main component
class ClickerGame extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      score: "0",
      plusPoints: 1,
      winScore: 100,
      win: false,
      clicks: 0,
      difficult: "Easy"
    }

    this.clickBtnMain = this.clickBtnMain.bind(this)
    this.clickBtnPlus = this.clickBtnPlus.bind(this)
    this.clickBtnRestart = this.clickBtnRestart.bind(this)
    this.changeScore = this.changeScore.bind(this)
    this.changeDifficult = this.changeDifficult.bind(this)
  }

  changeDifficult(value) {
    this.setState({ ...JSON.parse(value) })
  }

  changeScore() {
    if (this.state.score >= this.state.winScore && Boolean(this.state.plusPoints)) {
      console.log("Congratulations!")
      this.setState({plusPoints: 0, win: true})
    }
  }

  clickBtnMain() {
    this.setState({
      score: Number(this.state.score) + this.state.plusPoints,
      clicks: this.state.clicks + 1
    })
  }

  clickBtnPlus(plusObj) {

    if (this.state.score >= plusObj.price) {
      this.setState({
        plusPoints: this.state.plusPoints + Number(plusObj.value),
        score: this.state.score - plusObj.price
      })
    } else {
      console.log("you don`t have enough money")
    }
  }

  clickBtnRestart() {
    this.setState((score, plusPoints) => ({
      plusPoints: 1,
      score: 0,
      win: false,
      clicks: 0
    }))
  }
  
  render() {
    return (
      <>
      { 
        this.state.win 
        ? <Modal 
            handleClickRestart={this.clickBtnRestart}
            clicks={this.state.clicks}
            difficult={this.state.difficult}
          /> 
        : ""
      }
      <div className="app">
        <Header 
          score={this.state.score} 
          plusPoints={this.state.plusPoints}
          handleClick={this.clickBtnMain}
          handleChange={this.changeScore}
          winScore={this.state.winScore}
        />
        <Shop 
          clickBtnPlus={this.clickBtnPlus}
          plusPoints={this.state.plusPoints}/>
        <Footer
         handleClickBtn={this.clickBtnRestart}
         changeDifficult={this.changeDifficult}/>
      </div>
      </>
    )
  }
}

class App extends React.Component {
  render() {
    return (
      <div className="container">
        <ClickerGame/>
        <Leaderboard/>
      </div>
    )
  }
}

ReactDOM.render(
  <App/>,
  document.querySelector("#root")
)
